import { Skeleton, SkeletonProps } from 'antd';
import React from 'react';

export type AppSkeletonProps = SkeletonProps;

const AppSkeleton: React.FC<AppSkeletonProps> = props => {
  return <Skeleton {...props} />;
};

AppSkeleton.displayName = 'AppSkeleton';

export default AppSkeleton;
